import { ApplicationConfig, inject, LOCALE_ID } from '@angular/core';
import { provideAppInitializer } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { registerLocaleData } from '@angular/common';
import pt from '@angular/common/locales/pt';
import { ptBR as dateFnsPtBr } from 'date-fns/locale';
import { NZ_DATE_LOCALE, NzI18nService, provideNzI18n, pt_BR } from 'ng-zorro-antd/i18n';
import { provideCompanyDataGrid } from '@enacom/data-grid';

import { environment, provideAppPlatform } from '@base-platform/core';
import { appRoutes } from './app.routes';

/**
 * ng-zorro usa `pt-br` em getLocaleId(). Registrar só como `pt` deixa o DatePipe
 * sem dados quando o locale efetivo não é o padrão.
 */
registerLocaleData(pt);
registerLocaleData(pt, 'pt-br');

/** Host: providers globais + composição de rotas base + produto. */
export const appConfig: ApplicationConfig = {
  providers: [
    ...provideAppPlatform({ environment, routes: appRoutes }),
    provideAnimationsAsync(),
    { provide: LOCALE_ID, useValue: 'pt-br' },
    provideNzI18n(pt_BR),
    /** Ativa DateHelper por date-fns (evita DatePipe + fallback zh-cn). */
    { provide: NZ_DATE_LOCALE, useValue: dateFnsPtBr },
    provideAppInitializer(() => {
      inject(NzI18nService).setLocale(pt_BR);
    }),
    provideCompanyDataGrid(),
  ],
};
